module.exports = __webpack_public_path__ + "img/barlogo2.ad3080f6.webp";